export default "__VITE_ASSET__sszpAlCR__"